
export default function Testimonials() {
  const testimonials = [
    {
      name: '田中 花子様',
      age: '62歳',
      location: '東京都世田谷区',
      service: '遺品整理',
      rating: 5,
      comment: '母の遺品整理をお願いしました。思い出の品を一つひとつ丁寧に扱っていただき、本当に感謝しております。スタッフの方々の優しい対応に心が救われました。明朗会計で追加料金もなく、安心してお任せできました。',
      date: '2024年1月'
    },
    {
      name: '佐藤 一郎様',
      age: '58歳',
      location: '神奈川県横浜市',
      service: '生前整理',
      rating: 5,
      comment: '父の生前整理を依頼しました。遠方に住んでいるため不安でしたが、女性スタッフの方が丁寧に対応してくださり、父も安心して作業を見守っていました。必要なものと不要なものを一緒に考えてくださり、とても助かりました。',
      date: '2024年2月'
    },
    {
      name: '鈴木 美智子様',
      age: '67歳',
      location: '千葉県船橋市',
      service: '不用品回収',
      rating: 5,
      comment: '大型家具の処分に困っていましたが、即日対応していただけました。重い家具も丁寧に運び出してくださり、部屋がすっきりしました。料金も事前の見積り通りで、信頼できる業者さんだと思います。',
      date: '2024年3月'
    },
    {
      name: '山田 健太様',
      age: '54歳',
      location: '埼玉県さいたま市',
      service: 'ゴミ屋敷片付け',
      rating: 5,
      comment: '一人暮らしの叔父の部屋の片付けをお願いしました。かなり散らかっていましたが、スタッフの方々は嫌な顔一つせず、テキパキと作業してくださいました。秘密厳守で近隣への配慮も完璧でした。本当にありがとうございました。',
      date: '2023年12月'
    },
    {
      name: '高橋 由美様',
      age: '71歳',
      location: '東京都練馬区',
      service: '遺品整理・ご供養',
      rating: 5,
      comment: '夫の遺品整理とご供養をお願いしました。提携寺院でのお焚き上げも手配していただき、心の整理もつきました。遺品整理士の資格を持つスタッフの方が、故人への敬意を持って接してくださり、感動しました。',
      date: '2024年1月'
    },
    {
      name: '伊藤 正夫様',
      age: '65歳',
      location: '神奈川県川崎市',
      service: '特殊清掃',
      rating: 5,
      comment: '特殊な状況での清掃をお願いしました。プライバシーに配慮していただき、近隣にも気づかれることなく作業を完了していただきました。専門的な技術と機材で、部屋が見違えるようにきれいになりました。',
      date: '2023年11月'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-800 mb-4">お客様の声</h2>
          <p className="text-lg text-gray-600">
            多くのお客様から信頼をいただいております
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-gradient-to-br from-pink-50 to-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow cursor-pointer border border-pink-100"
            >
              <div className="flex items-center justify-between mb-4">
                <div>
                  <h3 className="font-bold text-gray-800 text-lg">{testimonial.name}</h3>
                  <p className="text-sm text-gray-500">{testimonial.age} / {testimonial.location}</p>
                </div>
                <div className="flex gap-1">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-lg w-4 h-4 flex items-center justify-center"></i>
                  ))}
                </div>
              </div>
              
              <div className="bg-green-100 text-green-700 text-sm font-medium px-3 py-1 rounded-full inline-block mb-4 whitespace-nowrap">
                {testimonial.service}
              </div>
              
              <p className="text-gray-700 leading-relaxed mb-4">
                {testimonial.comment}
              </p>
              
              <div className="text-xs text-gray-400 text-right">
                {testimonial.date}
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <div className="bg-green-600 text-white inline-block px-8 py-4 rounded-xl shadow-lg">
            <div className="text-3xl font-bold mb-2">お客様満足度</div>
            <div className="text-5xl font-bold">98.7%</div>
            <div className="text-sm mt-2">（2023年度実績）</div>
          </div>
        </div>
      </div>
    </section>
  );
}
